<template>
  <div class="ScreeningItemMenu">
    <DotMenuItem
      :text="mixWB('VIEW_IN_MILVA_ONLINE')"
      itemID="show-in-milva-online"
      @dot-item-click="onDotItemClick" />
    <DotMenuItem
      v-if="currentUser.isDeveloper"
      :text="mixWB('SHOW_IN_BACKEND')"
      itemID="show-in-backend"
      @dot-item-click="onDotItemClick" />
    <DotSplitLine />
    <template v-if="canBeEditedByCurrentUser && !isDemoUser">
      <DotMenuItem
        v-if="!isArchived"
        :text="mixWB('ARCHIVE')"
        itemID="archive"
        @dot-item-click="onDotItemClick" />
      <DotMenuItem
        v-else
        :text="mixWB('MAKE_ACTIVE_AGAIN')"
        itemID="make-active"
        @dot-item-click="onDotItemClick" />
    </template>
  </div>
</template>

<script>
import DotMenuItem from '@/components/DotMenu/DotMenuItem.vue'
import { mapGetters } from 'vuex'
import DotSplitLine from '@/components/DotMenu/DotSplitLine.vue'

export default {
  name: 'ScreeningItemMenu',
  props: {
    canBeEditedByCurrentUser: {
      type: Boolean,
      required: true,
    },
    isArchived: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'isDemoUser',
    ]),
  },
  methods: {
    onDotItemClick(itemID) {
      this.$emit('pass-to-parent', { name: 'menu-click', value: itemID })
      this.$emit('close-menu')
    },
  },
  components: {
    DotMenuItem,
    DotSplitLine,
  },
}
</script>

<style lang="stylus" scoped>
</style>
